import { CommonServiceIds } from 'azure-devops-extension-api'
import { inject } from 'vue'

import { getAzureService } from '@/utils/azure-devops-helpers/azure-service'
import { AZURE_DEVOPS_SDK } from '@/utils/azure-devops-helpers/general'
import { forgeRouter } from '@/utils/forge-helpers/general'
import { isCrossPlatformAppInjectionKey, isWebAppInjectionKey } from '@/utils/injection-keys'
import { IS_DEVELOPMENT } from '@root/app-modes'

export const useReloadPage = ({ appVariant = 'oboard' } = {}) => {
  const injectedIsWebApp = inject(isWebAppInjectionKey, false)
  const injectedIsCrossPlatformApp = inject(isCrossPlatformAppInjectionKey, false)

  const reloadPage = ({ isWebApp = false, isCrossPlatformApp = false } = {}) => {
    const _isWebApp = isWebApp || injectedIsWebApp

    if (_isWebApp || (IS_DEVELOPMENT && !AZURE_DEVOPS_SDK)) {
      location.reload()
      return
    }

    const _isCrossPlatformApp = isCrossPlatformApp || injectedIsCrossPlatformApp

    if (_isCrossPlatformApp) {
      const source = appVariant || 'installation-app'
      const message = { source, action: 'RELOAD' }
      window.parent.postMessage(message, '*')
      return
    }

    if (forgeRouter) {
      forgeRouter.reload()
      return
    }

    getAzureService(CommonServiceIds.HostNavigationService).then(azureNavService => {
      if (azureNavService) {
        azureNavService.reload()
      }
    })
  }

  return {
    reloadPage
  }
}
